import { render, staticRenderFns } from "./Kontak.vue?vue&type=template&id=f0a4a04c&scoped=true"
var script = {}
import style0 from "./Kontak.vue?vue&type=style&index=0&id=f0a4a04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a4a04c",
  null
  
)

export default component.exports